import { useLanguage } from '../../../contexts/useLanguage';
import scutLogo from '../../../assets/readdy/a646391ef0f23c13baff80a5aa8c77f1__e83148685c.png';
import hsuLogo from '../../../assets/readdy/6a0b16a8bea267efb1e50d3226820ee4__2202499637.png';

export default function Technology() {
  const { t } = useLanguage();

  return (
    <section id="technology" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs font-light text-gray-500 tracking-widest uppercase mb-3">
            {t('核心技术', 'Core Technology')}
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('扎实技术底座 产学研深度融合', 'Solid Technology Foundation with Deep Industry-Academia Integration')}
          </h2>
          <div className="w-24 h-1 bg-gray-900 rounded-full mx-auto"></div>
        </div>

        {/* Academic Collaboration Section */}
        <div className="mb-20">
          <div className="bg-gray-50 border border-gray-200 rounded-3xl p-12 hover:shadow-xl transition-all">
            <div className="text-center mb-10">
              <div className="flex flex-col items-center justify-center gap-6 mb-[55px] md:mb-8 md:flex-row md:gap-0 md:space-x-16">
                <img
                  src={scutLogo}
                  alt="SCUT"
                  className="w-40 object-contain hover:scale-105 transition-all"
                />
                <img
                  src={hsuLogo}
                  alt="HSU"
                  className="w-40 object-contain hover:scale-105 transition-all mb-4"
                />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('学术合作', 'Academic Collaboration')}</h3>
              <p className="text-gray-600 text-base">{t('与顶尖高校深度合作，推动AI技术创新与应用', 'Deep cooperation with top universities to promote AI technology innovation and application')}</p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="flex flex-col items-center text-center p-6 bg-white border border-gray-200 rounded-2xl hover:shadow-lg transition-all">
                <div className="w-14 h-14 flex items-center justify-center bg-gray-900 rounded-xl mb-4 flex-shrink-0">
                  <i className="ri-user-star-line text-2xl text-white"></i>
                </div>
                <h4 className="text-base font-semibold text-gray-900 mb-2">{t('教授指导', 'Professor Guidance')}</h4>
                <p className="text-sm text-gray-600">{t('顶尖高校知名AI教授提供指导', 'Renowned AI professors from top universities providing guidance')}</p>
              </div>
              <div className="flex flex-col items-center text-center p-6 bg-white border border-gray-200 rounded-2xl hover:shadow-lg transition-all">
                <div className="w-14 h-14 flex items-center justify-center bg-gray-500 rounded-xl mb-4 flex-shrink-0">
                  <i className="ri-graduation-cap-line text-2xl text-white"></i>
                </div>
                <h4 className="text-base font-semibold text-gray-900 mb-2">{t('博士团队', 'PhD Team')}</h4>
                <p className="text-sm text-gray-600">{t('名校博士作为核心技术骨干', 'PhDs from prestigious universities as core technical backbone')}</p>
              </div>
              <div className="flex flex-col items-center text-center p-6 bg-white border border-gray-200 rounded-2xl hover:shadow-lg transition-all">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-500 rounded-xl mb-4 flex-shrink-0">
                  <i className="ri-team-line text-2xl text-white"></i>
                </div>
                <h4 className="text-base font-semibold text-gray-900 mb-2">{t('实验室合作', 'Lab Partnership')}</h4>
                <p className="text-sm text-gray-600">{t('与顶级实验室深度研发合作', 'Deep R&D collaboration with top-tier labs')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* AI Interactive Engine and AIGC Engine */}
        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          {/* AI Interactive Engine */}
          <div className="bg-gray-500 rounded-3xl p-10 text-white hover:shadow-2xl hover:-translate-y-1 transition-all">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                <i className="ri-brain-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold">{t('AI交互引擎', 'AI Interactive Engine')}</h3>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <div className="font-medium mb-1">Transformer</div>
                  <div className="text-sm text-white/80">{t('大语言模型', 'LLM Model')}</div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <div className="font-medium mb-1">{t('人格进化', 'Personality Evolution')}</div>
                  <div className="text-sm text-white/80">{t('情感表达', 'Emotional Expression')}</div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <div className="font-medium mb-1">{t('情绪识别', 'Emotion Recognition')}</div>
                  <div className="text-sm text-white/80">{t('与华南理工吴贤铭AI实验室合作', 'Partnered with SCUT Wu Hsien-Ming AI Lab')}</div>
                </div>
              </div>
            </div>
          </div>

          {/* AIGC Engine */}
          <div className="bg-red-800 rounded-3xl p-10 text-white hover:shadow-2xl hover:-translate-y-1 transition-all">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                <i className="ri-palette-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold">{t('AIGC引擎', 'AIGC Engine')}</h3>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="text-center">
                <div className="text-3xl font-bold mb-1">95%</div>
                <div className="text-xs text-white/80">{t('角色控制', 'Character Control')}</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-1">92%</div>
                <div className="text-xs text-white/80">{t('场景切换', 'Scene Switching')}</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-1">98%</div>
                <div className="text-xs text-white/80">{t('内容合规', 'Content Compliance')}</div>
              </div>
            </div>

            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-sm">
                <i className="ri-check-line"></i>
                <span>{t('10万+/日创作任务 | 低延迟 | 高可用', '100K+/day Creation Tasks | Low Latency | High Availability')}</span>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <i className="ri-check-line"></i>
                <span>{t('与香港恒生大学合作', 'Partnered with Hang Seng University of Hong Kong')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Technology Focus Areas */}
        <div className="bg-gray-50 border border-gray-200 rounded-3xl p-12">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">{t('技术聚焦领域', 'Technology Focus Areas')}</h3>
          <div className="grid md:grid-cols-3 gap-10">
            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-gray-900 rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-all">
                <i className="ri-video-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">{t('视频AIGC生成', 'Video AIGC Generation')}</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                {t('先进的视频内容生成与处理技术', 'Advanced video content generation and processing technology')}
              </p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-gray-900 rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-all">
                <i className="ri-emotion-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">{t('情感感知', 'Emotion Perception')}</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                {t('实时情绪识别与情感计算算法', 'Real-time emotion recognition and affective computing algorithms')}
              </p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-gray-900 rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-all">
                <i className="ri-chat-smile-3-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">{t('智能交互', 'Intelligent Interaction')}</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                {t('多轮对话与个性化交互体验', 'Multi-turn dialogue and personalized interaction experience')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
